import { SvgIconProps } from 'ui/icons/SvgIcon';

export const ErrorStateWebError = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <svg
    width={height}
    height={width}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.1584 63.9998C13.1584 77.5789 18.5527 90.6018 28.1545 100.204C37.7564 109.806 50.7793 115.2 64.3584 115.2C77.9375 115.2 90.9604 109.806 100.562 100.204C110.164 90.6018 115.558 77.5789 115.558 63.9998C115.558 50.4207 110.164 37.3978 100.562 27.7959C90.9604 18.1941 77.9375 12.7998 64.3584 12.7998C50.7793 12.7998 37.7564 18.1941 28.1545 27.7959C18.5527 37.3978 13.1584 50.4207 13.1584 63.9998Z"
      fill="#F5F4F4"
    />
    <path
      d="M84.7693 52.7363H21.0739C20.395 52.7363 19.7438 53.006 19.2637 53.4861C18.7836 53.9662 18.5139 54.6174 18.5139 55.2963V96.424H87.3293V55.2963C87.3293 54.6174 87.0596 53.9662 86.5795 53.4861C86.0994 53.006 85.4482 52.7363 84.7693 52.7363Z"
      fill="white"
      stroke="#79347F"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M82.4717 57.5938H23.4394L23.3715 96.4238H82.4717V57.5938Z" fill="#EBD3F1" />
    <path
      d="M82.4717 57.5938H23.4394L23.3715 96.4238H82.4717V57.5938Z"
      stroke="#79347F"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5376 105.787C20.5376 106.347 23.9495 106.884 30.0227 107.28C36.0958 107.676 44.3328 107.899 52.9216 107.899C61.5104 107.899 69.7474 107.676 75.8205 107.28C81.8937 106.884 85.3056 106.347 85.3056 105.787C85.3056 105.227 81.8937 104.689 75.8205 104.293C69.7474 103.897 61.5104 103.675 52.9216 103.675C44.3328 103.675 36.0958 103.897 30.0227 104.293C23.9495 104.689 20.5376 105.227 20.5376 105.787Z"
      fill="#EBD3F1"
    />
    <path
      d="M93.4016 101.281H12.4416V97.697C12.4416 97.3575 12.5764 97.032 12.8165 96.7919C13.0565 96.5519 13.3821 96.417 13.7216 96.417H92.1216C92.4611 96.417 92.7866 96.5519 93.0267 96.7919C93.2667 97.032 93.4016 97.3575 93.4016 97.697V101.281Z"
      fill="white"
      stroke="#79347F"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M93.4016 101.281C85.8822 103.43 78.1 104.52 70.2797 104.52H35.5635C27.7432 104.52 19.961 103.43 12.4416 101.281H93.4016Z"
      fill="white"
      stroke="#79347F"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M59.0656 86.1605C58.6703 86.1612 58.2788 86.0836 57.9137 85.9323C57.5486 85.7809 57.2171 85.5587 56.9382 85.2786L52.9216 81.2619L48.905 85.2786C48.6256 85.5579 48.2939 85.7794 47.929 85.9305C47.564 86.0816 47.1728 86.1594 46.7778 86.1593C46.3828 86.1593 45.9916 86.0814 45.6267 85.9302C45.2617 85.7789 44.9302 85.5573 44.6509 85.2779C44.3716 84.9986 44.1501 84.6669 43.9989 84.302C43.8478 83.937 43.7701 83.5458 43.7701 83.1508C43.7702 82.7557 43.8481 82.3646 43.9993 81.9997C44.1505 81.6347 44.3721 81.3031 44.6515 81.0239L48.6681 77.0059L44.6515 72.988C44.1092 72.4196 43.8107 71.6616 43.82 70.876C43.8292 70.0904 44.1455 69.3396 44.7011 68.7842C45.2567 68.2288 46.0076 67.9127 46.7932 67.9037C47.5788 67.8947 48.3367 68.1933 48.905 68.7359L52.9216 72.7538L56.9382 68.7359C57.5023 68.1717 58.2673 67.8546 59.0651 67.8545C59.8629 67.8544 60.6281 68.1712 61.1923 68.7352C61.7565 69.2993 62.0736 70.0643 62.0737 70.8621C62.0738 71.6599 61.757 72.4251 61.1929 72.9893L57.175 77.0072L61.1929 81.0239C61.6133 81.4446 61.8996 81.9805 62.0154 82.5639C62.1313 83.1473 62.0716 83.7519 61.844 84.3014C61.6163 84.8509 61.2308 85.3205 60.7363 85.651C60.2418 85.9814 59.6604 86.1578 59.0656 86.1579V86.1605Z"
      fill="white"
      stroke="#79347F"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M57.4976 20.0342H112.68V63.9983H57.4976V20.0342Z" fill="#EBD3F1" />
    <path
      d="M57.5 30H112.5V64H57.5V30Z"
      stroke="#79347F"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M108.403 20.0342H61.7741C61.2124 20.0342 60.6562 20.1448 60.1373 20.3598C59.6183 20.5748 59.1468 20.8899 58.7497 21.2872C58.3526 21.6844 58.0376 22.156 57.8228 22.675C57.6079 23.194 57.4975 23.7502 57.4976 24.3119V30.2076H112.68V24.3119C112.68 23.7502 112.569 23.194 112.355 22.675C112.14 22.156 111.825 21.6844 111.428 21.2872C111.03 20.8899 110.559 20.5748 110.04 20.3598C109.521 20.1448 108.965 20.0342 108.403 20.0342Z"
      fill="white"
    />
    <path
      d="M108.403 20.0342H61.7741C60.6399 20.0342 59.5522 20.4847 58.7502 21.2867C57.9482 22.0887 57.4976 23.1765 57.4976 24.3107V30.2076H112.68V24.3107C112.68 23.7491 112.569 23.193 112.354 22.6741C112.139 22.1553 111.824 21.6838 111.427 21.2867C111.03 20.8896 110.559 20.5746 110.04 20.3597C109.521 20.1448 108.965 20.0342 108.403 20.0342Z"
      stroke="#79347F"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M61.7741 25.094C61.7741 25.3748 61.8294 25.653 61.9369 25.9125C62.0444 26.172 62.202 26.4078 62.4006 26.6064C62.5992 26.805 62.835 26.9625 63.0945 27.07C63.354 27.1775 63.6321 27.2328 63.913 27.2328C64.1939 27.2328 64.472 27.1775 64.7315 27.07C64.991 26.9625 65.2268 26.805 65.4254 26.6064C65.624 26.4078 65.7816 26.172 65.8891 25.9125C65.9965 25.653 66.0519 25.3748 66.0519 25.094C66.0519 24.8131 65.9965 24.5349 65.8891 24.2754C65.7816 24.0159 65.624 23.7802 65.4254 23.5815C65.2268 23.3829 64.991 23.2254 64.7315 23.1179C64.472 23.0104 64.1939 22.9551 63.913 22.9551C63.6321 22.9551 63.354 23.0104 63.0945 23.1179C62.835 23.2254 62.5992 23.3829 62.4006 23.5815C62.202 23.7802 62.0444 24.0159 61.9369 24.2754C61.8294 24.5349 61.7741 24.8131 61.7741 25.094Z"
      fill="#EBD3F1"
      stroke="#79347F"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M70.327 25.094C70.327 25.6612 70.5524 26.2053 70.9535 26.6064C71.3546 27.0075 71.8986 27.2328 72.4659 27.2328C73.0332 27.2328 73.5772 27.0075 73.9783 26.6064C74.3794 26.2053 74.6048 25.6612 74.6048 25.094C74.6048 24.5267 74.3794 23.9827 73.9783 23.5815C73.5772 23.1804 73.0332 22.9551 72.4659 22.9551C71.8986 22.9551 71.3546 23.1804 70.9535 23.5815C70.5524 23.9827 70.327 24.5267 70.327 25.094Z"
      fill="#EBD3F1"
      stroke="#79347F"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M78.88 25.094C78.88 25.6612 79.1054 26.2053 79.5065 26.6064C79.9076 27.0075 80.4516 27.2328 81.0189 27.2328C81.5862 27.2328 82.1302 27.0075 82.5313 26.6064C82.9324 26.2053 83.1578 25.6612 83.1578 25.094C83.1578 24.5267 82.9324 23.9827 82.5313 23.5815C82.1302 23.1804 81.5862 22.9551 81.0189 22.9551C80.4516 22.9551 79.9076 23.1804 79.5065 23.5815C79.1054 23.9827 78.88 24.5267 78.88 25.094Z"
      fill="#EBD3F1"
      stroke="#79347F"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M69.5667 41.4724C69.5667 42.0325 69.7892 42.5697 70.1853 42.9658C70.5814 43.3618 71.1186 43.5844 71.6787 43.5844C72.2389 43.5844 72.776 43.3618 73.1721 42.9658C73.5682 42.5697 73.7907 42.0325 73.7907 41.4724C73.7907 40.9122 73.5682 40.375 73.1721 39.9789C72.776 39.5829 72.2389 39.3604 71.6787 39.3604C71.1186 39.3604 70.5814 39.5829 70.1853 39.9789C69.7892 40.375 69.5667 40.9122 69.5667 41.4724Z"
      fill="white"
      stroke="#79347F"
      strokeWidth="1.25"
    />
    <path
      d="M96.3187 41.4724C96.3187 42.0325 96.5412 42.5697 96.9373 42.9658C97.3334 43.3618 97.8706 43.5844 98.4307 43.5844C98.9909 43.5844 99.5281 43.3618 99.9241 42.9658C100.32 42.5697 100.543 42.0325 100.543 41.4724C100.543 40.9122 100.32 40.375 99.9241 39.9789C99.5281 39.5829 98.9909 39.3604 98.4307 39.3604C97.8706 39.3604 97.3334 39.5829 96.9373 39.9789C96.5412 40.375 96.3187 40.9122 96.3187 41.4724Z"
      fill="white"
      stroke="#79347F"
      strokeWidth="1.25"
    />
    <path
      d="M102.554 50.7241C102.56 50.9926 102.513 51.2596 102.415 51.5096C102.317 51.7596 102.17 51.9874 101.983 52.1796C101.795 52.3719 101.571 52.5247 101.324 52.629C101.076 52.7333 100.811 52.787 100.542 52.787C100.274 52.787 100.008 52.7333 99.7603 52.629C99.5129 52.5247 99.2889 52.3719 99.1014 52.1796C98.914 51.9874 98.7669 51.7596 98.6688 51.5096C98.5708 51.2596 98.5238 50.9926 98.5305 50.7241C98.5305 49.6131 100.543 45.6963 100.543 45.6963C100.543 45.6963 102.554 49.6131 102.554 50.7241Z"
      fill="white"
      stroke="#79347F"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.0106 56.6411C78.7716 56.6412 78.5358 56.5867 78.3211 56.4818C78.1064 56.377 77.9185 56.2244 77.7717 56.0359C77.6249 55.8474 77.5231 55.6278 77.474 55.394C77.425 55.1601 77.43 54.9181 77.4886 54.6865C77.9177 53.0057 78.8942 51.5156 80.2641 50.4514C81.6341 49.3872 83.3194 48.8096 85.0541 48.8096C86.7888 48.8096 88.4741 49.3872 89.844 50.4514C91.214 51.5156 92.1905 53.0057 92.6195 54.6865C92.6782 54.9181 92.6832 55.1601 92.6341 55.394C92.5851 55.6278 92.4833 55.8474 92.3365 56.0359C92.1897 56.2244 92.0018 56.377 91.7871 56.4818C91.5724 56.5867 91.3365 56.6412 91.0976 56.6411C89.108 56.2161 87.087 55.955 85.0547 55.8603C83.022 55.9549 81.0006 56.2161 79.0106 56.6411Z"
      fill="white"
      stroke="#79347F"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
